module.exports = __webpack_public_path__ + "media/01.369cc066.wav";